// text marquee
document.addEventListener('DOMContentLoaded', function () {
    if ($('.product-marquee-items')) {
        $('.product-marquee-items').marquee({
            duration: 40000,
            delayBeforeStart: 0,
            direction: 'left',
            startVisible: true,
            duplicated: true
        });
    }
})

// product marquee & accordions

document.addEventListener('DOMContentLoaded', () => {

    let loveYourselTitle = document.querySelector('.daily-solution__title');
    function elem_in_visible_area(selector) {
        let elem_p = $(selector),
            elem_p_height = elem_p.height(),
            offset_top_el = elem_p.length > 0 && elem_p.offset().top,
            offset_bottom_el = offset_top_el + elem_p.height(),
            scrolled = $(window).scrollTop(),
            scrolled_bottom = scrolled + $(window).height();
        if (scrolled_bottom > offset_top_el && offset_bottom_el > scrolled) {
            return true;
        }
        return false;
    }

    $(window).scroll(function () {
        if (elem_in_visible_area(loveYourselTitle)) {
            loveYourselTitle?.classList.add('active')
        } else {
           loveYourselTitle?.classList.remove('active')
        }
    })

    function accordions(accordionsSelector, contentSelector, controlSelector, activeClass) {
        const accordions = document.querySelectorAll(accordionsSelector);

        accordions.forEach(el => {
            el.addEventListener('click', (e) => {
                const currentContent = e.currentTarget.querySelector(contentSelector),
                    currentController = e.currentTarget.querySelector(controlSelector);

                if (currentController) {
                    function hide(parent, content, controller) {
                        parent.classList.remove(activeClass);
                        content.style.maxHeight = '';
                        controller?.setAttribute('aria-expanded', false);
                        content?.setAttribute('aria-hidden', true)
                    }

                    if (el.classList.contains(activeClass) && e.target == currentController) {
                        hide(e.currentTarget, currentContent, currentController);
                    } else {

                        accordions.forEach(item => {
                            const content = item.querySelector(contentSelector),
                                controller = item.querySelector(controlSelector);

                            if (e.target != currentContent) {
                                hide(item, content, controller);
                            }
                        });

                        e.currentTarget.classList.add(activeClass);
                        currentContent.style.maxHeight = currentContent.scrollHeight + 'px';
                        currentController?.setAttribute('aria-expanded', true);
                        currentContent?.setAttribute('aria-hidden', false);
                    }
                }
            });
            accordions[0].click();
        });
    }

    accordions('.product-item-acc', '.product-item__content', '.product-item__title', 'active');

    if ($('.marquee-items')) {
        $('.marquee-items').marquee({
            duration: 100000,
            delayBeforeStart: 0,
            direction: 'left',
            startVisible: true,
            pauseOnHover: true,
            duplicated: true
        });
    }
})
// video slider
document.addEventListener('DOMContentLoaded', () => {
    const loveSwiper = new Swiper('.love-yourself-swiper', {

        direction: 'horizontal',
        loop: true,
        pagination: {
            el: '.swiper-pagination',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pauseOnMouseEnter: true,
        autoplay: {
            delay: 5000,
        },
        centeredSlides: true,

        breakpoints: {
            320: {
                slidesPerView: 'auto',
                spaceBetween: 0,
                centeredSlides: true
            },
            375: {
                slidesPerView: 'auto',
                spaceBetween: 0,
                centeredSlides: true
            },
            767: {
                slidesPerView: 'auto',
                spaceBetween: 48,
                centeredSlides: true
            },
            1023: {
                slidesPerView: 'auto',
                spaceBetween: 24,
                centeredSlides: true
            }
        }
    });

    const videos = document.body.querySelectorAll('.video-insta')
    const plays = document.body.querySelectorAll('.play-video')
    const sec = document.body.querySelectorAll('.love-yourself-section')

    const loveYourselfTitleSpans = document.body.querySelectorAll('.love-yourself-title span')
    const loveYourselfTitle = document.querySelector('.love-yourself-title')
    const loveYourselfSection = document.querySelector('.love-yourself-section');

    let swiperSlidePrev = document.querySelector('.swiper-slide-prev');

    var target = $('.love-yourself-title');
 
    var targetPos = target.length > 0 && target.offset().top;
    var winHeight = $(window).height();
    var scrollToElem = targetPos - winHeight;

    videos.forEach(video => {
        video.addEventListener('click', function () {
            if (this.paused) {
                videos.forEach(elem => {
                    elem.pause();
                    elem.muted = true;
                    elem.parentNode.classList.add('paused')
                })

                this.play()
                this.muted = false;
                this.parentNode.classList.remove('paused')
                loveSwiper.autoplay.stop()
            } else {

                this.pause()
                this.muted = true;
                this.parentNode.classList.add('paused')
                loveSwiper.autoplay.start()
            }
        })
    })

    plays.forEach(play => {
        play.addEventListener('click', () => {
            videos.forEach(elem => {
                elem.pause();
                elem.muted = true;
                elem.parentNode.classList.add('paused')
            })

            play.parentNode.classList.remove('paused')
            loveSwiper.autoplay.stop()
            play.nextElementSibling.play()
            play.nextElementSibling.muted = false;
        })
    })

    for (i = 0; i <= loveYourselfTitleSpans.length - 1; i++) {
        loveYourselfTitleSpans[i].style.animationDelay = `${i}00ms`
    }
});
// review slider
document.addEventListener('DOMContentLoaded', () => {
    const reviewsSwiper = new Swiper('.product-new-reviews__reviews-wrapper-swiper', {
        direction: 'horizontal',
        speed: 1000,
        pagination: {
            el: '.swiper-pagination',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                loop: true,
            },
            767: {
                slidesPerView: 2,
                spaceBetween: 48,
                loop: false,
            },
            1023: {
                allowTouchMove: false,
                enabled: true
            }
        },
        scrollbar: {
            el: '.swiper-scrollbar',
        },
        loopFillGroupWithBlank: true,
    });
});